import React from "react";

import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { bindActionCreators } from "redux";

import Form from "../Forms/Form";
import Loading from "../Loading";

class ModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.modalState,
      loading: false
    };

    this.toggle = this.toggle.bind(this);
    this.action = this.action.bind(this);
  }

  action() {
    this.setState({
      loading: true
    });
    this.props.action(this.props.formRedux.formBase.values);
    this.setState({
      loading: false
    });
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modalState}
          toggle={this.props.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.props.toggleModal}>
            {this.props.title}
          </ModalHeader>
          <ModalBody>
            {this.props.form ? (
              <Form
                fields={this.props.form}
                buttons=""
                onSubmit={this.enviar}
                initialValues={this.props.initialValues}
              />
            ) : (
              <p>{this.props.body}</p>
            )}
            {this.props.loading ? (
              this.state.loading ? (
                <Loading color="123abc" loading top="4" left="16" />
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </ModalBody>
          <ModalFooter>
            {this.props.form ? (
              <Button color="primary" onClick={this.action}>
                Enviar
              </Button>
            ) : (
              ""
            )}
            <Button
              color="secondary"
              onClick={() => this.props.toggleModal(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  general: state.general,
  formRedux: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent);
